module.exports = __webpack_public_path__ + "static/media/10.dd42b3b2.png";